import { CLEAR_CUSTOMER_SEARCH, SET_CUSTOMERS, SET_SELECTED_CUSTOMER } from 'constants/customerSearch';

const INITIAL_STATE = { customers: [], selectedCustomer: {} };

const customerSearch = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CUSTOMERS:
      return { customers: action.customers, selectedCustomer: {} };
    case SET_SELECTED_CUSTOMER:
      return { ...state, selectedCustomer: action.customer };
    case CLEAR_CUSTOMER_SEARCH:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default customerSearch;
